const values = {
    "SHOP": "Tienda",
    "SALES": "Ventas",
    "NEW_SHOP_ORDER": "Nueva venta",
    "NO_SHOP_ORDER_TITLE": "No hay ventas!!!",
    "NO_SHOP_ORDER_SUBTITLE": "Verifica si estás aplicando algún filtro",
}

export default values;